<script setup>
const { getShortName } = useHelpers()
const user = useUser()
const teams = useTeams()

const route = useRoute()
const sections = computed(() => {
  return [
    {
      id: 'home',
      url: '/home',
      label: 'Home',
      enabled: true
    },
    {
      id: 'certificates',
      url: '/certificates',
      label: 'My Certificates',
      enabled: true
    },
    {
      id: 'team',
      url: '/team/dashboard',
      label: 'Team Dashboard',
      enabled: user.data?.has_team_access && teams.isFeatureEnabled,
      target: '_blank'
    },
    {
      id: 'profile',
      url: '/profile',
      label: 'Profile',
      enabled: true,
      needsAttention: !user.data?.linkedin
    }
  ].map(section => ({
    ...section,
    active: section.id === 'dashboard' ? route.path === section.url : route.path.startsWith(section.url)
  })).filter(section => section.enabled)
})
</script>

<template>
  <AppDropdown>
    <template
      #trigger="{ isOpen }">
      <div class="inline-flex items-center gap-2">
        <UserBadge
          :theme="{
            avatarContainer: 'bg-gradient-to-b !from-dodger-blue !to-azure-radiance !size-11 !rounded-full',
            avatarIcon: 'text-white',
            name: 'hidden',
            occupation: 'hidden'
          }">
          <template #default="{ user }">
            <div class="flex size-full items-center justify-center font-extrabold uppercase text-white">
              <p>{{ getShortName(user.data.first_name, user.data.last_name) }}</p>
            </div>
          </template>
        </UserBadge>
        <svg
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class=""
          :class="{ 'rotate-180': isOpen }">
          <path
            d="M7.70369 7.29289C7.31316 7.68342 6.68 7.68342 6.28948 7.29289L0.703687 1.70711C0.0737225 1.07714 0.519891 7.3069e-07 1.4108 6.85722e-07L12.5824 1.21854e-07C13.4733 7.68867e-08 13.9194 1.07714 13.2895 1.70711L7.70369 7.29289Z"
            fill="#D9D9D9" />
        </svg>
      </div>
    </template>
    <div class="flex flex-col gap-4">
      <AppDropdownItem
        v-for="section in sections"
        :key="section.id">
        <NuxtLink
          :to="section.url"
          :title="section.enabled ? null : 'Coming Soon'"
          :target="section?.target || '_self'"
          class="inline-flex w-full items-center gap-3"
          :class="{
            ['text-azure-radiance']: section.active,
            [`dark:text-body-gray ${'hover:text-azure-radiance'}`]: section.enabled && !section.active,
            'cursor-not-allowed text-body-gray/50': !section.enabled,
          }">
          <span>
            {{ section.label }}
          </span>
          <span
            v-if="section.needsAttention"
            class="size-2 animate-pulse rounded-full bg-red-500 shadow-sm shadow-red-300 dark:shadow-red-700"
            aria-label="Attention required" />
        </NuxtLink>
      </AppDropdownItem>
      <AppDropdownItem class="text-left">
        <UserLogoutButton class="!font-normal hover:!text-azure-radiance dark:!text-body-gray" />
      </AppDropdownItem>
    </div>
  </AppDropdown>
</template>
